// src/routes/adminRoutes.js
import { lazy } from 'react';

const NoDataAvailable = lazy(() => import('../views/noDataAvailable'));
// const AdminDashboard = lazy(() => import('../component/admin/adminDashboard'));
const Dashboard = lazy(() => import('../component/admin/dashboard'));
const ResearchManagement = lazy(() => import('../component/admin/researchAdmin/customresResearch'));
const CustomerResearchDetails = lazy(() => import('../component/admin/researchAdmin/customerResearchDetails'));
// const TrackingManagement = lazy(() => import('../component/admin/trackingManagement'));
// const Reports = lazy(() => import('../component/admin/reports'));

const adminRoutes = [
  { path: '/admin/dashboard', element: <Dashboard />, role: "admin" , protected: true,},
  { path: '/admin/research', element: <ResearchManagement /> },
  { path: '/admin/research-details', element: <CustomerResearchDetails /> },
//   { path: '/admin/tracking', element: <TrackingManagement /> },
//   { path: '/admin/reports', element: <Reports /> },

  { path: '*', element: <NoDataAvailable /> }
];

export default adminRoutes;
